import { MantineThemeOverride } from "@mantine/core";

type TypographyObjType = Partial<MantineThemeOverride>;

export const mantineTypography: TypographyObjType = {
  fontFamily: "Roboto, sans-serif",
  lineHeights: {
    md: "135%",
  },
  fontSizes: {
    sm: "10px",
    md: "14px",
    lg: "18px",
    xl: "24px",
  },
  headings: {
    fontFamily: "Roboto, sans-serif",
  },
};
